import { BitmapLayer } from "@deck.gl/layers";
import { COGLayer } from "@developmentseed/deck.gl-geotiff";
import {
    type AerialImagesList,
    instanceOfPlumeImage,
    type PlumeImage,
} from "../../../apiClient/generated";
import { MAP_ZOOM_SHOW_DETAILS } from "../constants";

/**
 * Raster layer, supports rendering rasters based on the common `BaseGeotiffModel`
 * abstract model.
 */
export const RasterLayer = ({
    data,
    name,
    visible,
    zoomLevel,
    opacity,
    detail = false,
}: {
    data: PlumeImage[] | AerialImagesList[];
    name: string;
    visible: boolean;
    zoomLevel: number;
    opacity: number;
    detail?: boolean;
}) => {
    if (!data) {
        return [];
    }

    if (!detail && zoomLevel < MAP_ZOOM_SHOW_DETAILS) {
        return [];
    }

    // Filter images inside map view and return image array
    // Tiled images return a COG layer, so they can incrementally load data.
    return data.map((item: PlumeImage | AerialImagesList) => {
        let defaultHide = false;
        if (instanceOfPlumeImage(item)) {
            defaultHide = item.defaultHide;
        }

        if (item.isTiled) {
            return new COGLayer({
                id: `${name}_${item.id}`,
                geotiff: item.tiledImage,
                visible: visible && (!defaultHide || detail),
                opacity,
                onError: () => true,
            });
        }
        return new BitmapLayer({
            id: `${name}_${item.id}`,
            bounds: item.bounds as [number, number, number, number],
            image: item.originalImage,
            visible: visible && (!defaultHide || detail),
            opacity: opacity,
            onError: () => true,
        });
    });
};
